import ClearIcon from "@mui/icons-material/Clear";
import {
	Autocomplete,
	Box,
	CircularProgress,
	debounce,
	TextField,
} from "@mui/material";
import { useCallback, useState } from "react";
import { UseFormRegister } from "react-hook-form";
import type { IVisitorList } from "src/content/modules/visitor/type/visitorType";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
// Define the Country type

const VisitorSelectFieldList = ({
	register,
	fieldName,
	label,
	hideCustomLabel,
	isRequired,
	mt,
	onChange,
	defaultValue,
}: {
	register?: UseFormRegister<any>;
	fieldName: string;
	label?: string;
	hideCustomLabel?: boolean;
	isRequired?: boolean;
	mt?: "0";
	onChange?: (e: number) => void;
	defaultValue?: {
		country_id: number;
		country_name: string;
	};
}) => {
	const [search, setSearch] = useState("");
	const { data, isLoading } = useGetQueryWithTotal<IVisitorList[]>({
		endPoint: "/api/admin/visitor",
		queryKeys: ["Visitor"],
		params: {
			name: search,
		},
	});

	const handleSearch = useCallback(
		debounce((value) => {
			setSearch(value);
		}, 300),
		[]
	);

	return (
		<Box sx={{ mt: mt ? 0 : 2 }}>
			{!hideCustomLabel && (
				<label>
					{label}{" "}
					{isRequired && <span style={{ color: "red" }}>*</span>}
				</label>
			)}

			<Autocomplete
				//defaultValue={{ visitor_id: 69, user_fair_member_company_name:''} || null}
				options={data?.data || []}
				getOptionLabel={(option: IVisitorList) =>
					option?.visitor_first_name + " " + option.visitor_last_name
				}
				// onInputChange={debounce((_, value) => {
				// 	setSearch(value);
				// }, 300)}
				onChange={(_, value: IVisitorList) => {
					register &&
						register(fieldName).onChange({
							target: {
								name: fieldName,
								value: value ? value.visitor_id : "",
							},
						});
					if (value?.visitor_id) {
						onChange && onChange(value?.visitor_id);
					}
				}}
				isOptionEqualToValue={(option, value) =>
					option?.visitor_id === value?.visitor_id
				}
				loading={isLoading}
				clearIcon={
					<span
						onClick={() => {
							setSearch("");
						}}
					>
						<ClearIcon fontSize='small' />
					</span>
				}
				renderInput={(params) => (
					<TextField
						{...params}
						placeholder='Enter Visitor'
						required={isRequired}
						label={hideCustomLabel ? label : ""}
						variant='outlined'
						onChange={(value) => handleSearch(value?.target?.value)}
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<>
									{isLoading ? (
										<CircularProgress
											color='inherit'
											size={20}
										/>
									) : null}
									{params.InputProps.endAdornment}
								</>
							),
						}}
					/>
				)}
			/>
		</Box>
	);
};

export default VisitorSelectFieldList;
